import { render, staticRenderFns } from "./OctSnackbar.vue?vue&type=template&id=72e5c17f&scoped=true&"
import script from "./OctSnackbar.vue?vue&type=script&lang=js&"
export * from "./OctSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./OctSnackbar.vue?vue&type=style&index=0&id=72e5c17f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5c17f",
  null
  
)

export default component.exports